import httpClient from './httpClient';

export const BACK_IN_STOCK_END_POINT = '/backoffice/back-in-stock-notifications';
export const getBackInStockAPI = (params = {}) => httpClient.get(`${BACK_IN_STOCK_END_POINT}`, { params });
